import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { TrashIcon } from "../../../ui/icons/trash"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { PopupForm } from "../../../ui/organisms/popupForm"
import { GetByIdPersonalManagement, resetGetByIdPersonalManagementResourcesStatus } from "../slice"
import AddOtherInfo from "./boxPopup/add"
import EditOtherInfo from "./boxPopup/edit"
import { DeleteOtherInfo, GetByIdOtherInfo, addOthInfoInstance, resetDeleteStatus, resetGetByidStatus, resetOthInfoInstance, resetOtherInfoCreateStatus, resetUpdateStatus, setPMId, setUpdateRequest } from "./slice"

export default function BoxOtherInfo() {
    const dispatch = useAppDispatch()
    const otherInfoState = useAppSelector(state => state.PMOtherInfo)
    const PMState = useAppSelector(state => state.personalManagement)
    const [openPopup, setOpenPopup] = useState<boolean>(false)
    const [openEditPopup, setOpenEditPopup] = useState<boolean>(false)

    useEffect(() => {
        dispatch(resetOthInfoInstance())
        if (PMState.currentPersonalManagementId) {
            dispatch(setPMId(PMState.currentPersonalManagementId))
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId))
        }
    }, [PMState.currentPersonalManagementId])

    useEffect(() => {
        dispatch(resetOthInfoInstance())
        if (
            PMState.getByIdPersonalManagementResourcesStatus === 'successfully' &&
            PMState.getByIdPersonalManagementResourcesResponse?.otherInformationIds
        ) {
            dispatch(resetGetByIdPersonalManagementResourcesStatus('idle'))
            for (let index = 0; index < PMState.getByIdPersonalManagementResourcesResponse.otherInformationIds.length; index++) {
                dispatch(GetByIdOtherInfo(PMState.getByIdPersonalManagementResourcesResponse.otherInformationIds[index].toString()))
            }
        }
    }, [PMState.getByIdPersonalManagementResourcesStatus])

    useEffect(() => {
        if (otherInfoState.getByIdOtherInfoStatus === 'successfully' && PMState.getByIdPersonalManagementResourcesResponse) {
            dispatch(addOthInfoInstance(otherInfoState.GetByIdOtherInfoResponse))
            dispatch(resetGetByidStatus('idle'))
        }
    }, [otherInfoState.getByIdOtherInfoStatus])

    useEffect(() => {
        dispatch(resetOthInfoInstance())
        if (otherInfoState.DeleteIdOtherInfoStatus === 'successfully' && PMState.currentPersonalManagementId) {
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId))
            dispatch(resetDeleteStatus('idle'))
        }
    }, [otherInfoState.DeleteIdOtherInfoStatus])

    useEffect(() => {
        dispatch(resetOthInfoInstance())
        if (otherInfoState.OthInfoUpdateStatus === 'successfully' && PMState.currentPersonalManagementId) {
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId))
            dispatch(resetUpdateStatus('idle'))
        }
    }, [otherInfoState.OthInfoUpdateStatus])

    useEffect(() => {
        dispatch(resetOthInfoInstance())
        if (otherInfoState.createOtherInfoStatus === 'successfully' && PMState.currentPersonalManagementId) {
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId))
            dispatch(resetOtherInfoCreateStatus('idle'))
        }
    }, [otherInfoState.createOtherInfoStatus])

    return (
        <div className="p-6">
            <div className="space-y-3">
                <div className="flex items-center justify-between">
                    <span className="font-bold text-2xl text-neutral-850">Altre Informazioni</span>
                    <ButtonComponent
                        size="md"
                        iconPosition="off"
                        variant="solid"
                        color="orange"
                        label="Aggiungi altre informazioni"
                        onClick={() => setOpenPopup(true)}
                    />
                </div>

                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table className="w-full border-collapse text-text-md min-w-[1300px]">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Madrelingua</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Altre Lingue</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cap. Lettura</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cap. Scrittura</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cap. Orale</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cap. Personali</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cap. Relazionali</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cap. Organizzative</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cap. Tecniche</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Altre Competenze</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[72px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {otherInfoState.otherInfoInstances.length === 0 ? (
                                <tr>
                                    <td colSpan={11} className="px-3 py-3 text-left text-neutral-500 bg-white">
                                        Nessuna informazione trovata
                                    </td>
                                </tr>
                            ) : (
                                otherInfoState.otherInfoInstances.map((info, index) => (
                                    <tr
                                        key={info.id}
                                        className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{info.nativeLanguage}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{info.otherLanguage}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{info.readSkill}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{info.writeSkill}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{info.oralExpressionSkill}</td>
                                        <td className="px-3 py-2 text-neutral-700">{info.personalSkill}</td>
                                        <td className="px-3 py-2 text-neutral-700">{info.relationalSkill}</td>
                                        <td className="px-3 py-2 text-neutral-700">{info.organizationalSkill}</td>
                                        <td className="px-3 py-2 text-neutral-700">{info.technicalSkill}</td>
                                        <td className="px-3 py-2 text-neutral-700">{info.otherSkill}</td>
                                        <td className="px-3 py-2 w-[72px]">
                                            <div className="flex items-center justify-center gap-2">
                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => {
                                                        dispatch(setUpdateRequest(info))
                                                        setOpenEditPopup(true)
                                                    }}
                                                >
                                                    <EditIcon color={"Orange"} size={18} />
                                                </button>
                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => {
                                                        if (info.id) dispatch(DeleteOtherInfo(info.id))
                                                    }}
                                                >
                                                    <TrashIcon color={"Orange"} size={18} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {openPopup && (
                <PopupForm title="Aggiungi Informazioni" close={() => setOpenPopup(false)} width>
                    <AddOtherInfo close={() => setOpenPopup(false)} />
                </PopupForm>
            )}

            {openEditPopup && (
                <PopupForm title="Modifica Informazioni" close={() => setOpenEditPopup(false)} width>
                    <EditOtherInfo close={() => setOpenEditPopup(false)} />
                </PopupForm>
            )}
        </div>
    )
}